import React, { useState } from "react";
import logo from "../assets/logo.png";
import { Menu, X } from "lucide-react";
import { User } from 'lucide-react';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 w-full z-50 bg-transparent text-[#000000]">
      {/* Desktop Layout */}
      <div className="hidden lg:flex justify-between items-center font-manrope text-normal lg:text-lg px-8 py-6">
        <a href="#about" className="cursor-pointer hover:opacity-60 transition">
          About
        </a>
        <a href="#home" className="text-center">
          <img
            src={logo}
            alt="Eye Care Optical"
            className="h-20 mx-auto cursor-pointer"
          />
        </a>
        <a href="#contact" className="cursor-pointer hover:opacity-60 transition">
          Contact Us
        </a>
      </div>

      {/* Mobile Layout */}
      <div className="flex lg:hidden justify-between items-center px-4 py-4">
        {/* Left: Menu Button */}
        <button onClick={() => setMenuOpen(!menuOpen)} className="p-2">
          {menuOpen ? (
            <X className="h-6 w-6 text-[#3471B8]" />
          ) : (
            <Menu className="h-6 w-6 text-[#3471B8]" />
          )}
        </button>

        {/* Center: Logo */}
        <a href="#home">
          <img src={logo} alt="Eye Care Optical" className="h-16 cursor-pointer" />
        </a>

        {/* Right: Dummy Box (same size as left button) */}
        <div className="p-2 w-6 h-6" />

        {/* <a href="tel:+917025890816" className="flex items-center gap-2 p-2 text-[#3471B8] font-semibold hover:underline">
          <User className="h-5 w-5" />
        </a> */}

      </div>


      {/* Dropdown Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white shadow-lg rounded-xl mx-4 mt-2 py-4 animate-slideDown">
          <a
            href="#about"
            onClick={() => setMenuOpen(false)}
            className="block w-full py-2 px-4 text-center font-semibold font-manrope text-black ounded-md transition"
          >
            About
          </a>
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="block w-full py-2 px-4 text-center font-semibold font-manrope text-black rounded-md transition"
          >
            Contact Us
          </a>
        </div>
      )}
    </header>
  );
}

export default Header;
